<template>
  <div id="realTimeChart">
    <VueApexCharts type="line" ref="chart" height="650" :options="chartOptions" :series="series"></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import { inspectChartsColors } from "../../../colors.js";

export default {
  name: "ApexRealTimeChart",
  components: {
    VueApexCharts,
  },
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      required: false,
    },
    rate: {
      type: Number,
      required: false,
      default: 1,
    },
  },

  data: () => ({
    timer: null,
    series: [
      {
        data: [],
      },
    ],
    chartOptions: {
      colors: inspectChartsColors,
      chart: {
        id: "realtime",
        height: 500,
        type: "line",
        animations: {
          enabled: false,
          easing: "linear",
          dynamicAnimation: {
            speed: 1000,
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      /*       title: {
        text: "Dynamic Updating Chart",
        align: "left",
      }, */
      markers: {
        size: 0,
      } /*
      tooltip: {
        y: {
          show: false,
        },
        x: {
          show: false,
        },
      }, */,
      /*       xaxis: {
        type: "datetime",
      }, */
      /*       yaxis: {
        max: 100,
      }, */
      legend: {
        show: true,
      },
    },
  }),
  mounted() {
    this.timer = setInterval(() => {
      if (this.enabled === true) {
        this.updateChart();
      }
    }, this.rate * 1000);
  },

  methods: {
    updateChart() {
      let obj;
      let series = [];

      for (let index = 0; index < this.data.length; index++) {
        obj = {
          name: this.data[index].name,
          data: this.data[index].data,
        };

        series.push(obj);
      }

      /*       this.$refs.chart.updateSeries(series, true, false); */

      this.$refs.chart.updateSeries(series);

      /*       this.$refs.chart.updateSeries(series, true, true);

      this.$refs.chart.updateSeries() */
      /* this.$refs.chart.updateSeries(obj,tr) */

      /*       let obj;

      series = [];

      for (let index = 0; index < this.data.length; index++) {
        obj = {
          name: this.data[index].name,
          data: this.data[index].data,
        };

        //series.push(obj);
        this.$set(this.series, index, obj);
      } */
    },
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
  },
};
</script>
